import React from "react";
import { Card, CardContent, Grid, Typography, Chip } from "@mui/material";
import { formatCurrency } from "../utils/accountsHelpers";

const BankAccountList = ({ bankAccounts = [] }) => {
  if (!bankAccounts.length) {
    return (
      <Typography color="text.secondary">No bank accounts found.</Typography>
    );
  }

  return (
    <Grid container spacing={2}>
      {bankAccounts.map((item) => (
        <Grid item xs={12} md={6} lg={4} key={item.id}>
          <Card>
            <CardContent>
              <Typography variant="h6">{item.accountName}</Typography>
              <Typography variant="body2" color="text.secondary">
                {item.bankName}
              </Typography>
              <Chip
                sx={{ my: 1 }}
                label={item.status || "active"}
                size="small"
                color="info"
              />
              <Typography variant="body2">
                Code: {item.bankAccountCode}
              </Typography>
              <Typography variant="body2">
                Book Balance: {formatCurrency(item.currentBookBalance || 0)}
              </Typography>
              <Typography variant="body2">
                Bank Balance: {formatCurrency(item.currentBankBalance || 0)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default BankAccountList;
